import { useParams } from 'react-router-dom'
import { dateSort, projNumSort } from '../../utilities/services/sortConditionally'
// import DeleteApplication from '../DeleteApplication/DeleteApplication'
import TrademarkApplicationsFilter from '../TrademarkApplicationsFilter/TrademarkApplicationsFilter'
import TrademarkApplicationsListItem from '../TrademarkApplicationsListItem/TrademarkApplicationsListItem'
// import UpdateApplication from '../UpdateApplication/UpdateApplication'
import './TrademarkApplicationsList.css'

export default function TrademarkApplicationsList({user, trademarkApplicationPreferences, trademarkApplications, updateTrademarkApplications, sortHeader, setSortHeader, sortOrder, setSortOrder, toggleNotifications, isMobile}) {
    const datesArray = ['priorityDate', 'filingDate', 'registrationDate', 'nationalEntryDate', 'nextActionDueDate']
    const params = useParams();

    const handleTableHeaderClick = (evt) => {
        const header = evt.target.id;
        const newSortOrder = sortOrder === 'asc' ? 'desc' : 'asc'
        setSortHeader(header);
        setSortOrder(newSortOrder);

        let sortedApplications = [...trademarkApplications];
        if (header === 'RPNumber') {
            sortedApplications = projNumSort(newSortOrder, header, sortedApplications);
        } else if (datesArray.includes(header)) {
            sortedApplications = dateSort(newSortOrder, header, sortedApplications);
        } else {
            sortedApplications.sort((a, b) => {
            if (newSortOrder === 'asc') {
                return ((typeof(a[header])==='string' ? a[header].toLowerCase() : a[header]) > (typeof(b[header])==='string' ? b[header].toLowerCase() : b[header])) ? 1 : -1;
            } else {
                return ((typeof(a[header])==='string' ? a[header].toLowerCase() : a[header]) < (typeof(b[header])==='string' ? b[header].toLowerCase() : b[header])) ? 1 : -1;
            }
            });
        }
        updateTrademarkApplications(sortedApplications);
    }
  
    return (
    <div className='TrademarkApplicationsList'>
        { !(params.clientID) &&
        <div className='filterContainer'>
            <TrademarkApplicationsFilter user={user} updateTrademarkApplications={updateTrademarkApplications} isMobile={isMobile} sortHeader={sortHeader} />
        </div>
        }
        <div className='trademarkApplicationsTable'>
          <table className=''>
            { trademarkApplicationPreferences &&
            <>
            <thead>
                <tr>
                    {!trademarkApplicationPreferences.includes('RPNumber') &&
                    <th id='RPNumber' onClick={handleTableHeaderClick} className='RPNumber'>
                        <div className='tableHeaderWithArrow'><div>RP Number&nbsp;&nbsp;</div>
                            { sortHeader==='RPNumber'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!trademarkApplicationPreferences.includes('applicationNumber') &&
                    <th id='applicationNumber' onClick={handleTableHeaderClick} className='applicationNumber'>
                        <div className='tableHeaderWithArrow'><div>Application Number&nbsp;&nbsp;</div>
                            { sortHeader==='applicationNumber'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!trademarkApplicationPreferences.includes('applicationType') &&
                    <th id='applicationType' onClick={handleTableHeaderClick} className='applicationType'>
                        <div className='tableHeaderWithArrow'><div>Application Type&nbsp;&nbsp;</div>
                            { sortHeader==='applicationType'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!trademarkApplicationPreferences.includes('trademarkType') &&
                    <th id='trademarkType' onClick={handleTableHeaderClick} className='trademarkType'>
                        <div className='tableHeaderWithArrow'><div>Trademark Type&nbsp;&nbsp;</div>
                            { sortHeader==='trademarkType'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!trademarkApplicationPreferences.includes('filingDate') &&
                    <th id='filingDate' onClick={handleTableHeaderClick} className='filingDate dateField'>
                        <div className='tableHeaderWithArrow'><div>Filing Date&nbsp;&nbsp;</div>
                            { sortHeader==='filingDate'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!trademarkApplicationPreferences.includes('trademarkDescription') &&
                    <th id='trademarkDescription' onClick={handleTableHeaderClick} className='trademarkDescription'>
                        <div className='tableHeaderWithArrow'><div>Trademark Description&nbsp;&nbsp;</div>
                            { sortHeader==='trademarkDescription'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!trademarkApplicationPreferences.includes('applicationStatus') &&
                    <th id='applicationStatus' onClick={handleTableHeaderClick} className='applicationStatus'>
                        <div className='tableHeaderWithArrow'><div>Application Status&nbsp;&nbsp;</div>
                            { sortHeader==='applicationStatus'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!trademarkApplicationPreferences.includes('trademarkClasses') &&
                    <th id='trademarkClasses' onClick={handleTableHeaderClick} className='trademarkClasses'>
                        <div className='tableHeaderWithArrow'><div>Trademark Classes&nbsp;&nbsp;</div>
                            { sortHeader==='trademarkClasses'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!trademarkApplicationPreferences.includes('clientName') &&
                    <th id='clientName' onClick={handleTableHeaderClick} className='clientName'>
                        <div className='tableHeaderWithArrow'><div>Client&nbsp;&nbsp;</div>
                            { sortHeader==='clientName'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!trademarkApplicationPreferences.includes('clientID') &&
                    <th id='clientID' onClick={handleTableHeaderClick} className='clientID'>
                        <div className='tableHeaderWithArrow'><div>Client ID&nbsp;&nbsp;</div>
                            { sortHeader==='clientID'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!trademarkApplicationPreferences.includes('filingFirm') &&
                    <th id='filingFirm' onClick={handleTableHeaderClick} className='filingFirm'>
                        <div className='tableHeaderWithArrow'><div>Filing Firm&nbsp;&nbsp;</div>
                            { sortHeader==='filingFirm'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!trademarkApplicationPreferences.includes('firmRefNumber') &&
                    <th id='firmRefNumber' onClick={handleTableHeaderClick} className='firmRefNumber'>
                        <div className='tableHeaderWithArrow'><div>Firm Ref&nbsp;&nbsp;</div>
                            { sortHeader==='firmRefNumber'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!trademarkApplicationPreferences.includes('contact') &&
                    <th id='contact' onClick={handleTableHeaderClick} className='contact'>
                        <div className='tableHeaderWithArrow'><div>Contact&nbsp;&nbsp;</div>
                            { sortHeader==='contact'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!trademarkApplicationPreferences.includes('applicants') &&
                    <th id='applicants' onClick={handleTableHeaderClick} className='applicants'>
                        <div className='tableHeaderWithArrow'><div>Applicants&nbsp;&nbsp;</div>
                            { sortHeader==='applicants'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!trademarkApplicationPreferences.includes('applicantAddress') &&
                    <th id='applicantAddress' onClick={handleTableHeaderClick} className='applicantAddress'>
                        <div className='tableHeaderWithArrow'><div>Applicant Address&nbsp;&nbsp;</div>
                            { sortHeader==='applicantAddress'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!trademarkApplicationPreferences.includes('highlyRelevantTrademarkClass') &&
                    <th id='highlyRelevantTrademarkClass' onClick={handleTableHeaderClick} className='highlyRelevantTrademarkClass'>
                        <div className='tableHeaderWithArrow'><div>Highly Relevant Trademark Class&nbsp;&nbsp;</div>
                            { sortHeader==='highlyRelevantTrademarkClass'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!trademarkApplicationPreferences.includes('filing') &&
                    <th id='filing' onClick={handleTableHeaderClick} className='filing'>
                        <div className='tableHeaderWithArrow'><div>Filing Basis&nbsp;&nbsp;</div>
                            { sortHeader==='filing'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!trademarkApplicationPreferences.includes('priorityDate') &&
                    <th id='priorityDate' onClick={handleTableHeaderClick} className='priorityDate dateField'>
                        <div className='tableHeaderWithArrow'><div>Priority Date&nbsp;&nbsp;</div>
                            { sortHeader==='priorityDate'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!trademarkApplicationPreferences.includes('priorityApplication') &&
                    <th id='priorityApplication' onClick={handleTableHeaderClick} className='priorityApplication'>
                        <div className='tableHeaderWithArrow'><div>Priority Application&nbsp;&nbsp;</div>
                            { sortHeader==='priorityApplication'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!trademarkApplicationPreferences.includes('registrationNumber') &&
                    <th id='registrationNumber' onClick={handleTableHeaderClick} className='registrationNumber'>
                        <div className='tableHeaderWithArrow'><div>Registration Number&nbsp;&nbsp;</div>
                            { sortHeader==='registrationNumber'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!trademarkApplicationPreferences.includes('feesPaid') &&
                    <th id='feesPaid' onClick={handleTableHeaderClick} className='feesPaid'>
                        <div className='tableHeaderWithArrow'><div>Fees Paid&nbsp;&nbsp;</div>
                            { sortHeader==='feesPaid'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!trademarkApplicationPreferences.includes('registrationDate') &&
                    <th id='registrationDate' onClick={handleTableHeaderClick} className='registrationDate dateField'>
                        <div className='tableHeaderWithArrow'><div>Registration&nbsp;&nbsp;</div>
                            { sortHeader==='registrationDate'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!trademarkApplicationPreferences.includes('nationalEntryDate') &&
                    <th id='nationalEntryDate' onClick={handleTableHeaderClick} className='nationalEntryDate dateField'>
                        <div className='tableHeaderWithArrow'><div>National Entry&nbsp;&nbsp;</div>
                            { sortHeader==='nationalEntryDate'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!trademarkApplicationPreferences.includes('examinationByOffice') &&
                    <th id='examinationByOffice' onClick={handleTableHeaderClick} className='examinationByOffice'>
                        <div className='tableHeaderWithArrow'><div>Examination By Office&nbsp;&nbsp;</div>
                            { sortHeader==='examinationByOffice'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!trademarkApplicationPreferences.includes('approvalOrDenial') &&
                    <th id='approvalOrDenial' onClick={handleTableHeaderClick} className='approvalOrDenial'>
                        <div className='tableHeaderWithArrow'><div>Approval Or Denial&nbsp;&nbsp;</div>
                            { sortHeader==='approvalOrDenial'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!trademarkApplicationPreferences.includes('NOA') &&
                    <th id='NOA' onClick={handleTableHeaderClick} className='NOA'>
                        <div className='tableHeaderWithArrow'><div>NOA&nbsp;&nbsp;</div>
                            { sortHeader==='NOA'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!trademarkApplicationPreferences.includes('maintenanceOfRegistration') &&
                    <th id='maintenanceOfRegistration' onClick={handleTableHeaderClick} className='maintenanceOfRegistration'>
                        <div className='tableHeaderWithArrow'><div>Maintenance Of Registration&nbsp;&nbsp;</div>
                            { sortHeader==='maintenanceOfRegistration'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!trademarkApplicationPreferences.includes('lastAction') &&
                    <th id='lastAction' onClick={handleTableHeaderClick} className='lastAction'>
                        <div className='tableHeaderWithArrow'><div>Last Action&nbsp;&nbsp;</div>
                            { sortHeader==='lastAction'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!trademarkApplicationPreferences.includes('nextAction') &&
                    <th id='nextAction' onClick={handleTableHeaderClick} className='nextAction'>
                        <div className='tableHeaderWithArrow'><div>Next Action&nbsp;&nbsp;</div>
                            { sortHeader==='nextAction'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!trademarkApplicationPreferences.includes('nextActionDueDate') &&
                    <th id='nextActionDueDate' onClick={handleTableHeaderClick} className='nextActionDueDate dateField'>
                        <div className='tableHeaderWithArrow'><div>Next Action Due&nbsp;&nbsp;</div>
                            { sortHeader==='nextActionDueDate'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!trademarkApplicationPreferences.includes('notes') &&
                    <th id='notes' onClick={handleTableHeaderClick} className='notes'>
                        <div className='tableHeaderWithArrow'><div>Notes&nbsp;&nbsp;</div>
                            { sortHeader==='notes'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!trademarkApplicationPreferences.includes('trademarkClassesForSearch') &&
                    <th id='trademarkClassesForSearch' onClick={handleTableHeaderClick} className='trademarkClassesForSearch'>
                        <div className='tableHeaderWithArrow'><div>Trademark Classes For Search&nbsp;&nbsp;</div>
                            { sortHeader==='trademarkClassesForSearch'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!trademarkApplicationPreferences.includes('trademarkClassesForFiling') &&
                    <th id='trademarkClassesForFiling' onClick={handleTableHeaderClick} className='trademarkClassesForFiling'>
                        <div className='tableHeaderWithArrow'><div>Trademark Classes For Filing&nbsp;&nbsp;</div>
                            { sortHeader==='trademarkClassesForFiling'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!trademarkApplicationPreferences.includes('driveFolderLocation') &&
                    <th id='driveFolderLocation' onClick={handleTableHeaderClick} className='driveFolderLocation'>
                        <div className='tableHeaderWithArrow'><div>Folder Location&nbsp;&nbsp;</div>
                            { sortHeader==='driveFolderLocation'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!trademarkApplicationPreferences.includes('createdAt') &&
                    <th id='createdAt' onClick={handleTableHeaderClick} className='createdAt dateField'>
                        <div className='tableHeaderWithArrow'><div>Creation&nbsp;&nbsp;</div>
                            { sortHeader==='createdAt'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!trademarkApplicationPreferences.includes('updatedAt') &&
                    <th id='updatedAt' onClick={handleTableHeaderClick} className='updatedAt dateField'>
                        <div className='tableHeaderWithArrow'><div>Last Update&nbsp;&nbsp;</div>
                            { sortHeader==='updatedAt'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                </tr>
            </thead>
            <tbody>
                { trademarkApplications.length === 0 ?
                <tr>
                <td colSpan='12' className='noApplications text-center'>No Applications Found</td>
                </tr>
                :
                <>
                {trademarkApplications.map(application => (
                <TrademarkApplicationsListItem user={user} key={application._id} applicationItem={application} updateApplications={updateTrademarkApplications} isMobile={isMobile} toggleNotifications={toggleNotifications} trademarkApplicationPreferences={trademarkApplicationPreferences} />
                ))}
                </>
                }
            </tbody>
            </>
            }
          </table>
        </div>
        <div className='footer'>
          <div>
            page count
          </div>
          <div>
            toggle
          </div>
        </div>
    </div>
  )
}
